import {
  TRecordConfig,
  TVitalDataResponse,
  TVitalSettingsResponse,
  VitalListEntryBuilders,
} from '../../types/life-id';
import bloodPressureEntry from './entries/blood-pressure-entry';
import healthRateEntry from './entries/health-rate-entry';
import temperatureEntry from './entries/temperature-entry';
import glucoseEntry from './entries/glucose-entry';
import cholesterolEntry from './entries/cholesterol-entry';
import breathRateEntry from './entries/breath-rate-entry';
import oxygenSaturationEntry from './entries/oxygen-saturation-entry';
import { BMI_BAR_CHART_CONFIG } from './entries/bmi.entry.data';
import { WAIST_BAR_CHART_CONFIG } from './entries/waist.entry.data';
import { COLOR_TEXT_PRIMARY_COLOR_06 } from '@hilbi/web-common/assets/styles/colors';

export const RECORD_TYPE_SETTINGS: TRecordConfig = {
  HR: {
    unit: 'bpm',
    valueSelectors: ['bpm'],
    serverKey: ['heartRate'],
    urlPart: 'heart-rate',
  },
  CHOLESTEROL: {
    unit: 'mmol/l',
    valueSelectors: ['cholesterol'],
    serverKey: ['cholesterol'],
    urlPart: 'cholesterol',
  },
  GLUCOSE: {
    unit: 'mmol/l',
    valueSelectors: ['glucose'],
    serverKey: ['glucose'],
    urlPart: 'glucose',
  },
  BLOOD_PRESSURE: {
    unit: ['mmHg', 'mmHg'],
    valueSelectors: ['systolic', 'diastolic'],
    serverKey: ['bloodPressureSystolic', 'bloodPressureDiastolic'],
    urlPart: 'blood-pressure',
  },
  TEMPERATURE: {
    unit: 'celsius',
    valueSelectors: ['temperature'],
    serverKey: ['temperature'],
    urlPart: 'body-temperature',
  },
  BREATHING_RATE: {
    unit: 'brpm',
    valueSelectors: ['breathRate'],
    serverKey: ['breathRate'],
    urlPart: 'breath-rate',
  },
  OXYGEN_SATURATION: {
    unit: '%',
    valueSelectors: ['oxygenSaturation'],
    serverKey: ['oxygenSaturation'],
    urlPart: 'oxygen-saturation',
  },
  BMI: {
    unit: '',
    valueSelectors: ['bmi'],
    serverKey: ['bodyMeasure'],
    urlPart: 'body-measure',
    barchartWidget: {
      config: BMI_BAR_CHART_CONFIG,
      barChartWidgetProps: {
        indicatorConfig: {
          left: '0%',
          color: COLOR_TEXT_PRIMARY_COLOR_06,
        },
        lineWidth: `${100 / BMI_BAR_CHART_CONFIG.ranges.length}%`,
        labels: BMI_BAR_CHART_CONFIG.labels,
        ranges: BMI_BAR_CHART_CONFIG.ranges,
        isEmpty: true,
      },
    },
  },
  WAIST: {
    unit: 'cm',
    serverKey: ['waistCircumference'],
    urlPart: 'waist-circumference',
    valueSelectors: ['waistCircumference'],
    barchartWidget: {
      config: WAIST_BAR_CHART_CONFIG, // this config is overwritten based on gender
      barChartWidgetProps: {
        indicatorConfig: {
          left: '0',
          color: COLOR_TEXT_PRIMARY_COLOR_06,
        },
        lineWidth: `${100 / WAIST_BAR_CHART_CONFIG.ranges.length}%`,
        labels: WAIST_BAR_CHART_CONFIG.labels,
        ranges: WAIST_BAR_CHART_CONFIG.ranges,
        isEmpty: true,
      },
    },
  },
};

const VITAL_ENTRY_BUILDERS: VitalListEntryBuilders = [
  bloodPressureEntry,
  healthRateEntry,
  temperatureEntry,
  glucoseEntry,
  cholesterolEntry,
  breathRateEntry,
  oxygenSaturationEntry,
];

export default function getVitalEntryList(
  vitalData: TVitalDataResponse | null,
  vitalDataSettings: TVitalSettingsResponse | null,
) {
  return VITAL_ENTRY_BUILDERS.map((builder) =>
    builder(vitalData, vitalDataSettings, RECORD_TYPE_SETTINGS),
  );
}
